import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/assets";

export const Michelchef = () => {
  const { t } = useLang();
  const m = t.michelchef;
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="michelchef-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <span className="eyebrow">— {m.label}</span>
            <p className="mt-4 text-xs font-semibold uppercase tracking-[0.16em] text-muted">{m.kicker}</p>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-3xl md:text-5xl leading-tight text-ink">{m.title}</h2>
            <p className="mt-5 text-base md:text-lg text-muted leading-relaxed">{m.body}</p>
            <ul className="mt-8 space-y-4">
              {m.points.map((p, i) => (
                <li key={i} className="flex items-start gap-3" data-testid={`michelchef-point-${i}`}>
                  <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-tricolor-green text-white flex items-center justify-center">
                    <Check size={14} />
                  </span>
                  <span className="text-ink/80">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative">
              <div className="overflow-hidden rounded-[2rem] border border-line bg-white shadow-[0_30px_80px_-30px_rgba(0,0,0,0.25)] h-[50vh] md:h-[62vh] flex items-center justify-center p-6">
                <img src={IMAGES.magnetron} alt="MICHELCHEF MAGNETRON" loading="lazy" decoding="async" className="w-full h-full object-contain" data-testid="michelchef-image" />
              </div>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="absolute -bottom-5 right-5 bg-ink text-white rounded-2xl px-5 py-3 shadow-lg"
              >
                <span className="text-sm font-semibold">{m.badge}</span>
              </motion.div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
